import type { ReactNode } from 'react';
import type { LegacyPermission } from '../config/permissions';
import { getLegacyAuthClaims, hasLegacyPermission } from '../lib/auth-claims';

/**
 * The old panel's `<CheckAccess permission>` — renders its children only when
 * the session holds the permission, `null` otherwise. Every legacy screen gate
 * below replays the source's exact permission strings.
 */
export function LegacyCheckAccess({
  children,
  permission,
}: {
  children: ReactNode;
  permission: LegacyPermission;
}) {
  const hasAccess = hasLegacyPermission(getLegacyAuthClaims(), permission);
  return hasAccess ? <>{children}</> : null;
}
